import { defineStore } from "pinia";

import modelClass from "@models/leader";
import * as getters from "@modelStores/helpers/getters-helper";

export const useLeaderStore = defineStore("leader-store", {
  state: () => {
    return {
      resources: [] as Record<string, unknown>[],
    };
  },
  getters: {
    ...getters,
    modelClass: () => modelClass,
  },
});
